import {
    apiRequest,
    pendidikanDetail
} from "../../../../../services/adapters/kepegawaian/pendidikanService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pendidikanDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository